import { API } from "api";
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { UTILS } from "utils";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import AppSwitch from "components/ui/AppSwitch";
import AppSimpleTable from "components/ui/AppSimpleTable";

const StoreAccessRightsList = (props) => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const getStoreList = (result) => {
    let arr = [];
    if (
      result.success === 1 &&
      UTILS.isValidObject(["data", "pulledStores"], result)
    ) {
      arr = [...result.data.pulledStores];
      const modifiedArr = arr.map((obj) => ({ ...obj, isON: false }));
      arr = modifiedArr;
      return arr;
    }
    UTILS.HANDLE_ERROR_NOTIFICATION(
      "topRight",
      "error",
      t("There are not stores")
    );
    return arr;
  };

  const getUserStoresByUserId = (result) => {
    let tempArr = getStoreList(result[0]);
    if (result[1].success === 1 && UTILS.isValidObject(["data"], result[1])) {
      const arr = [...result[1].data];
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        tempArr = tempArr.map((el) =>
          el._id === element.storeId._id ? { ...el, isON: true } : el
        );
      }
      setStores(tempArr);
    }
  };

  const addUserToStore = async (sId, val) => {
    const userDetail = UTILS.getCurrentUser();
    const result = await API.ADD_NEW_STORE_ADMIN({
      token: userDetail.token,
      userType: props.user.userType,
      adminId: props.user._id,
      storeId: sId,
      brandId: userDetail.brandId,
    });
    if (result.success == 1) {
      const arr = [...stores];
      const modifiedArr = arr.map((el) =>
        el._id === sId ? { ...el, isON: val } : el
      );
      setStores(modifiedArr);
    }
  };

  const deleteUserFromStore = async (sId, val) => {
    const userDetail = UTILS.getCurrentUser();
    const result = await API.DELETE_STORE_ADMIN({
      token: userDetail.token,
      userType: props.user.userType,
      adminId: props.user._id,
      storeId: sId,
      brandId: userDetail.brandId,
    });
    if (result.success == 1) {
      const arr = [...stores];
      const modifiedArr = arr.map((el) =>
        el._id === sId ? { ...el, isON: val } : el
      );
      setStores(modifiedArr);
    }
  };

  const handleValues = (key, val) => {
    if (val) addUserToStore(key, val);
    else deleteUserFromStore(key, val);
  };

  const tableData = useMemo(
    () =>
      stores.map((row) => ({
        ...row,
        storeName: row.baseLanguage?.name ?? "",
        address: row.manualAddress ?? "",
      })),
    [stores]
  );

  const columns = [
    {
      title: t("Store"),
      key: "store",
      dataIndex: "storeName",
    },
    {
      title: t("Address"),
      key: "address",
      dataIndex: "address",
      render: (value) => <span title={value}>{value}</span>,
    },
    {
      title: t("Access"),
      key: "access",
      dataIndex: "isON",
      width: "140px",
      render: (_, row) => (
        <div className="flex w-full justify-center">
          <AppSwitch
            label=""
            checked={!!row.isON}
            onChange={(checked) => handleValues(row._id, checked)}
          />
        </div>
      ),
    },
  ];

  const getUserDataWithStores = async () => {
    if (!props.user?._id) return;
    const userDetail = UTILS.getCurrentUser();
    setLoading(true);
    try {
      const result = await API.GET_DATA_FOR_USERS_WITH_STORE_LIST({
        token: userDetail.token,
        brandId: userDetail.brandId,
        userId: props.user._id,
        language: "EN",
      });
      getUserStoresByUserId(result);
    } catch (e) {
      UTILS.errorNotification(
        e?.message || t("Something went wrong. Please try again.")
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserDataWithStores();
  }, [props.user?._id]);

  return (
    <div className="w-full bg-white text-left">
      <div className="mb-5 text-center">
        <h2 className="m-0 text-20px font-semibold text-gray-900">
          {t("Grant Access to")}
        </h2>
        <p className="mt-2 text-16px font-medium text-indigo-600">
          [{props.user?.email}]
        </p>
        <p className="mt-2 text-sm leading-relaxed text-gray-500">
          {t(
            "Allow User to Manage Live Orders, Order History and Items for Selected Stores"
          )}
        </p>
      </div>
      <Spin spinning={loading}>
        <AppSimpleTable columns={columns} data={tableData} />
      </Spin>
    </div>
  );
};

StoreAccessRightsList.propTypes = {
  user: PropTypes.object,
};

export default StoreAccessRightsList;
